// extracted by mini-css-extract-plugin
export default {"leds":"Led_leds__XXkTr","ledContent":"Led_ledContent__gzdsi","led":"Led_led__8oPKF","ledsTablet":"Led_ledsTablet__ZXtZV","informationLink":"Led_informationLink__8blVs"};